import { datadogRum } from '@datadog/browser-rum';
import getConfig from 'next/config';
import { useEffect } from 'react';
import { useSession } from 'next-auth/react';

export default function DatadogRumInit() {
    const session = useSession();

    useEffect(() => {
        const {
            publicRuntimeConfig: { ddClientToken: clientToken, ddApplicationId: applicationId }
        } = getConfig();
        if (applicationId && clientToken) {
            datadogRum.init({
                applicationId,
                clientToken,
                site: 'datadoghq.com',
                service: 'hb-finance-http-client',
                env: 'prod',
                version: '1.0.0',
                sessionSampleRate: 100,
                sessionReplaySampleRate: 30,
                silentMultipleInit: true,
                defaultPrivacyLevel: 'mask-user-input',
                trackUserInteractions: true,
                trackResources: true,
                trackLongTasks: true
            });

            datadogRum.startSessionReplayRecording();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (session.data?.user) {
            const {
                user: { _id: userId, email, name, accountId: userAccountId },
                accountId: sessionAccountId
            } = session.data;

            datadogRum.setUser({
                id: userId,
                email,
                name,
                accountId: userAccountId || sessionAccountId || undefined
            });
        }
    }, [session.data, session.data?.user?._id, session.data?.user?.email, session.data?.user?.name, session.data?.accountId]);

    return null;
}
